import React from 'react';
import './About.css';

function About() {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Me</h2>
        <div className="divider"></div>
        <div className="about-content">
          <div className="about-text">
            <p className="about-intro">
              As a passionate architect and interior design enthusiast, I believe that great design 
              transcends aesthetics—it shapes experiences and transforms the way we live.
            </p>
            <div className="education">
              <h3>Education & Background</h3>
              <div className="education-item">
                <div className="education-icon"></div>
                <div className="education-details">
                  <h4>Bachelor's Degree in Architecture</h4>
                  <p>Comprehensive study in architectural design, theory, and practice</p>
                </div>
              </div>
              <div className="education-item">
                <div className="education-icon education-icon-2"></div>
                <div className="education-details">
                  <h4>Interior Architecture Student</h4>
                  <p>Currently advancing expertise in interior spatial design and human-centered environments</p>
                </div>
              </div>
            </div>
            <div className="philosophy">
              <h3>Design Philosophy</h3>
              <p>
                My approach centers on minimalist principles, where every element serves a purpose. 
                I strive to create harmonious spaces that balance functionality with artistic expression, 
                bringing together clean lines, natural light, and thoughtful material selection.
              </p>
            </div>
          </div>
          <div className="about-skills">
            <h3>Expertise</h3>
            <div className="skills-grid">
              <div className="skill-item">
                <div className="skill-icon skill-icon-1"></div>
                <h4>Architectural Design</h4>
                <p>Conceptual development and spatial planning</p>
              </div>
              <div className="skill-item">
                <div className="skill-icon skill-icon-2"></div>
                <h4>Interior Design</h4>
                <p>Aesthetic and functional interior solutions</p>
              </div>
              <div className="skill-item">
                <div className="skill-icon skill-icon-3"></div>
                <h4>3D Visualization</h4>
                <p>Realistic rendering and presentation</p>
              </div>
              <div className="skill-item">
                <div className="skill-icon skill-icon-4"></div>
                <h4>Material Selection</h4>
                <p>Curating textures and finishes</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About;

